import AuthButton from "./AuthButton";
import { APPLICATION_NAME } from "../../util/constants";
import InternalLink from "./Link";
import AppBar from "./AppBar";
import Toolbar from "./Toolbar";
import FavoritesDropdown from "./FavoritesDropdown";
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";
import { mergeSxStyles } from "../../styles/util";

const AppLink = ({ sx, ...props }) => (
  <InternalLink to="/" disableHighlightCurrent {...props} sx={mergeSxStyles(sx, (theme) => theme.typography.h4)}>
    {APPLICATION_NAME}
  </InternalLink>
);

const sizingStyles = () => {
  return {
    minHeight: "44px"
  };
};

export default function Navbar() {
  const { isLoggedIn } = useRoleAuthentication()

  return (
    <AppBar>
      <Toolbar>
        <AppLink />
        {isLoggedIn && <FavoritesDropdown className="margin-left-auto margin-right-3" />}
        <AuthButton 
          className={!isLoggedIn ? 'margin-left-auto' : undefined} 
          sx={sizingStyles} />
      </Toolbar>
    </AppBar>
  );
}
